const SecurityTierLevels = {
    SameDevice: 2,
    SamePerson: 3,
    MaxLevel: 4
};
export { SecurityTierLevels }